import { Accordion, Typography } from "@/components/kit";
import { useState } from "react";
import classNames from "classnames";
import { Field, FieldProps } from "formik";
import {
  CountriesInput,
  PhoneNumber,
  TextField,
  TextFieldDate,
} from "@/components/kit";
import SvgIcon from "@/components/common/SvgIcon";
import TextArea from "@/components/kit/TextArea";
import AddProfilePhoto from "./AddProfilePhoto";

const PersonalInfo = () => {
  const [isOpenAdminPersonalInformation, setIsOpenAdminPersonalInformation] =
    useState<number | undefined>(0);
  return (
    <Accordion
      isOpen={isOpenAdminPersonalInformation === 0}
      onChange={() => {
        setIsOpenAdminPersonalInformation((p) => (p === 0 ? undefined : 0));
      }}
      title={
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <Typography variant="Title5-Regular">
              👤 Admin personal information{" "}
            </Typography>
          </div>

          {isOpenAdminPersonalInformation === 0 && (
            <Typography color="text-gray-300" variant="Body3-Regular">
              Add personal contact and identification details to help complete
              the employee profile.
            </Typography>
          )}
        </div>
      }
      descriptionClassName={classNames("!mt-0 !px-6", {
        "!py-0": isOpenAdminPersonalInformation !== 0,
        "!pb-4": isOpenAdminPersonalInformation === 0,
      })}
      headerClassName={classNames("!px-6 !py-5")}
    >
      <div className="flex flex-col gap-5">
        <AddProfilePhoto />
        <div className="flex flex-col gap-5">
          <Typography variant="Body1-Medium">Home address</Typography>
          <Field name="country">
            {({
              field,
              meta: { error },
              form: { setFieldValue },
            }: FieldProps) => (
              <CountriesInput
                {...field}
                error={error}
                //   label="Country"
                placeholder="Country"
                onChange={(val) => {
                  setFieldValue("country", val.code);
                }}
              />
            )}
          </Field>
          <div className="flex gap-4">
            <Field name="province">
              {({ field, meta: { error } }: FieldProps) => (
                <TextField {...field} error={error} label="State" />
              )}
            </Field>
            <Field name="city">
              {({ field, meta: { error } }: FieldProps) => (
                <TextField {...field} error={error} label="City" />
              )}
            </Field>
          </div>

          <Field name="address">
            {({ field, meta: { error } }: FieldProps) => (
              <TextField {...field} error={error} label="Address" />
            )}
          </Field>
          <Field name="postalCode">
            {({ field, meta: { error } }: FieldProps) => (
              <TextField {...field} error={error} label="Postal code" />
            )}
          </Field>
        </div>

        <div className="flex flex-col gap-5">
          <Typography variant="Body1-Medium">Contact</Typography>

          <Field name="phoneNumber">
            {({
              field,
              meta: { error },
              form: { setFieldValue },
            }: FieldProps) => (
              <PhoneNumber
                {...field}
                error={error}
                placeholder="Phone number"
                onChange={(e) => {
                  setFieldValue("phoneNumber", e);
                }}
              />
            )}
          </Field>
        </div>
        <div className="flex flex-col gap-5">
          <Typography variant="Body1-Medium">Birthday</Typography>
          <Field name="birthDate">
            {({
              field,
              meta: { error },
              form: { setFieldValue },
            }: FieldProps) => (
              <TextFieldDate
                {...field}
                error={error}
                onChange={(value) => {
                  setFieldValue("birthDate", value);
                }}
                label="Use calendar"
                endAdornment={
                  <SvgIcon iconName="calendar" className="w-5 h-5" />
                }
              />
            )}
          </Field>
        </div>
        <div className="flex flex-col gap-5">
          <Typography variant="Body1-Medium">Description</Typography>
          <Field name="description">
            {({ field, meta: { error } }: FieldProps) => (
              <TextArea {...field} error={error} label="Type here" />
            )}
          </Field>
        </div>
      </div>
    </Accordion>
  );
};

export default PersonalInfo;
